import { render, staticRenderFns } from "./handleDocumentContainer.pug?vue&type=template&id=3539740d&lang=pug&"
import script from "./handleDocumentContainer.js?vue&type=script&lang=js&"
export * from "./handleDocumentContainer.js?vue&type=script&lang=js&"
import style0 from "./handleDocumentContainer.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/lauramunozruiz/multiasistencia/selfcarefront/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3539740d')) {
      api.createRecord('3539740d', component.options)
    } else {
      api.reload('3539740d', component.options)
    }
    module.hot.accept("./handleDocumentContainer.pug?vue&type=template&id=3539740d&lang=pug&", function () {
      api.rerender('3539740d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/Document/views/handleDocumentContainer/index.vue"
export default component.exports